jQuery(document).ready(function($){
  $("#mob-head-default-search").click(function(e){
    e.preventDefault();
    $(".search-overlay").toggleClass("open");
  });
  
  $(".close-overlay").click(function(e){
    e.preventDefault();
    $(".search-overlay").removeClass("open");
  });


  $("#desk-head-default-search").on("click", function(e) {
    $(".desk-search .search").toggleClass("open");
    $(".desk-search").toggleClass("close-icon");
    e.stopPropagation()
  });
  $(document).on("click", function(e) {
    if ($(e.target).is(".desk-search .search") === false) {
      $(".desk-search .search").removeClass("open");
      $(".desk-search").removeClass("close-icon");
    }
  });
  
});
